import React from "react";
import "./Maintenance";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Tooltip,
  AppBar,
  Toolbar,
  Typography
} from "@material-ui/core";
import { detailByAttributeAndType } from "../../../utils/generic";
import camelcaseKeys from "camelcase-keys";
import DenseTable from "../../Dashboard/RenderTable";
import {
  GetSectionPermission,
  getSynchStatus,
  PaperComponent
} from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import { IoMdCloseCircleOutline } from "react-icons/io";

const CData = [
  { key: "AttributeSubType", name: "Priority" },
  { key: "WorkOrderId", name: "Work Order Id" },
  { key: "AssetId", name: "Asset Id" },
  { key: "Datacenter", name: "Data Center Name" },
  { key: "JobType", name: "Job Type" },
  { key: "ReceivedDate", name: "Received Date", format: "DateTime" },
  { key: "DueDate", name: "Due Date", format: "DateTime" },
  { key: "ClosedDate", name: "Closed Date", format: "DateTime" },
  { key: "Requestor", name: "Requestor" },
  { key: "Type", name: "Type" },
  { key: "Status", name: "Status" },
  { key: "ServiceLocation", name: "Service Location" },
  { key: "Technician", name: "Technician" },
  { key: "WorkHours", name: "Work Hours" },
  {
    key: "PrivateNote",
    name: "Private Note",
    clickable: true
  },
  {
    key: "PublicNote",
    name: "Public Note",
    clickable: true
  },
  { key: "ServiceDescription", name: "Description", width: 450 },
  { key: "Source", name: "Source" }
];
class MaintenanceInProgressWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MaintenanceList: [],
      conditions: [],
      rawData: [],
      SortedRawData: [],
      IsConditionOpen: false,
      FiltersView: false,
      SelectedAttribute: undefined,
      syncStatus: undefined,
      ignoreColumns: []
    };
  }

  componentDidMount() {
    this.GetMaintenanceDataI(this.props.propertyId);
  }
  componentWillReceiveProps(newProps) {
    if (newProps.propertyId != this.props.propertyId) {
      this.GetMaintenanceDataI(newProps.propertyId);
    }
  }

  /** Maintenance data */
  GetMaintenanceDataI = propertyId => {
    const params = {
      propertyId: propertyId
    };

    apiRequest({
      url: API_URL.maintenance.MaintenanceInProgressSummary,
      params
    }).then(MaintenanceList => {
      this.setState({
        MaintenanceList: MaintenanceList.data,
        conditions: camelcaseKeys(MaintenanceList.condition),
        rawData: MaintenanceList.rawData,
        ignoreColumns: MaintenanceList.ignoreColumns,
        syncStatus: ((MaintenanceList.syncStatus || [])[0] || {}).SyncStatus
      });
    });
  };

  /** details */
  getDetailByAttributeAndType = (attributeName, type) => {
    let result;
    if (attributeName != "Total Work Orders In Progress") {
      result = detailByAttributeAndType(
        attributeName,
        type,
        this.state.rawData
      );
    } else {
      const SortedRawData = this.state.rawData;
      result = SortedRawData.filter(value => value.AttributeSubType == type);
    }

    this.setState({
      SortedRawData: result,
      IsConditionOpen: true,
      SelectedAttribute: attributeName + " (" + type + ")"
    });
  };

  render() {
    const {
      MaintenanceList,
      IsConditionOpen,
      conditions,
      SortedRawData,
      FiltersView,
      SelectedAttribute,
      syncStatus,
      ignoreColumns
    } = this.state;

    const permission = GetSectionPermission(
      SECTIONS.MAINTENANCE,
      SECTIONS.MAINTENANCE_IN_PROGRESS
    );
    const ShowData = permission.showData;

    return (
      <>
        <div className={"maintenance-widget-wrapper col-xs-12"}>
          <div className={"maintenance-title-div row"}>
            <div className={"col-xs-12 center-xs"}>
              {"Maintenance In Progress"}{" "}
              {ShowData && (
                <Tooltip title={"View Filters"}>
                  <IconButton
                    onClick={() =>
                      this.setState({
                        IsConditionOpen: true,
                        FiltersView: true
                      })}
                    size={"small"}
                  >
                    <InfoOutlined fontSize={"small"} />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
          <div>
            <table id={"maintenance-widget-table"}>
              <thead>
                <tr>
                  <th />
                  <th
                    style={{
                      color: "var(--error--color)",
                      paddingBottom: "8px"
                    }}
                  >
                    {"HIGH\r"}
                  </th>
                  <th
                    style={{
                      color: "var(--warning--color)",
                      paddingBottom: "8px"
                    }}
                  >
                    {"MED\r"}
                  </th>
                  <th
                    style={{
                      color: "var(--success--color)",
                      paddingBottom: "8px"
                    }}
                  >
                    {"LOW\r"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {(MaintenanceList || []).map((item, index) => (
                  <tr key={"MaintenanceInProgressList" + index}>
                    <td className={"w-70"} style={{ paddingLeft: "0px" }}>
                      {" "}
                      {item["attributeName"]}{" "}
                    </td>
                    <td
                      onClick={() =>
                        ShowData &&
                        this.getDetailByAttributeAndType(
                          item["attributeName"],
                          "High"
                        )}
                      className={
                        "bordered-td w-10 " +
                        (ShowData && item["high"] != 0 && "pointer underline")
                      }
                    >
                      {" "}
                      {item["high"] != 0 ? item["high"] : "-"}
                    </td>
                    <td
                      onClick={() =>
                        ShowData &&
                        this.getDetailByAttributeAndType(
                          item["attributeName"],
                          "Medium"
                        )}
                      className={
                        "bordered-td w-10 " +
                        (ShowData && item["medium"] != 0 && "pointer underline")
                      }
                    >
                      {" "}
                      {item["medium"] != 0 ? item["medium"] : "-"}
                    </td>
                    <td
                      onClick={() =>
                        ShowData &&
                        this.getDetailByAttributeAndType(
                          item["attributeName"],
                          "Low"
                        )}
                      className={
                        "bordered-td w-10 " +
                        (ShowData && item["low"] != 0 && "pointer underline")
                      }
                    >
                      {" "}
                      {item["low"] != 0 ? item["low"] : "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {IsConditionOpen && (
          <Dialog
            maxWidth={"md"}
            open={IsConditionOpen}
            onClose={() =>
              this.setState({ IsConditionOpen: false, FiltersView: false })}
            aria-labelledby={"responsive-dialog-title"}
            PaperComponent={PaperComponent}
            fullScreen={!FiltersView}
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar>
                <Typography variant={"h6"} style={{ flex: "1" }}>
                  {FiltersView ? (
                    <DialogTitle
                      style={{ cursor: "move" }}
                      id={"responsive-dialog-title"}
                      className={"white-label"}
                    >
                      {"Maintenance In Progress"}
                      <span className={"condition-label white-label"}>
                        {"(Applied filters)\r"}
                      </span>
                    </DialogTitle>
                  ) : (
                    <DialogTitle
                      style={{ cursor: "move" }}
                      id={"responsive-dialog-title"}
                    >
                      {SelectedAttribute}
                    </DialogTitle>
                  )}
                </Typography>
                <Tooltip title={"Close"}>
                  <IconButton
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => {
                      this.setState({
                        IsConditionOpen: false,
                        FiltersView: false
                      });
                    }}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>

            <DialogContent>
              <DialogContentText>
                {FiltersView ? (
                  conditions &&
                  conditions.map(item => (
                    <div className={"col-xs-12"}>
                      <div className={"col-xs-12 start-xs condition-heading"}>
                        <b>{item.attributeName}</b>{" "}
                      </div>
                      <div>
                        {item.filterCondition.split("|").map(condition => (
                          <div className={"col-xs-11 condition-label"}>
                            {condition}{" "}
                          </div>
                        ))}{" "}
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <div>
                      <DenseTable
                        columns={CData}
                        data={SortedRawData}
                        ignoreColumns={ignoreColumns}
                        config={{
                          minRows: 10
                          // evenRowClass: "table-even",
                          // oddRowClass: "table-odd",
                        }}
                      />
                    </div>
                  </div>
                )}
                {syncStatus && (
                  <span className={"data-sync-text"}>
                    {getSynchStatus(syncStatus)}
                  </span>
                )}
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
      </>
    );
  }
}
export default MaintenanceInProgressWidget;
